import { Timestamp as FirestoreTimestamp } from 'firebase/firestore';

/** "2026-07-27"  →  "kd20260727" */
export function kantoordagDateKey(isoDate: string): string {
    return 'kd' + isoDate.replace(/-/g, '');
}

export function toIsoDate(value: unknown): string {
    if (!value) return '';
    if (value instanceof FirestoreTimestamp) return value.toDate().toISOString().substring(0, 10);
    if (typeof value === 'string') return value;
    const ts = value as { seconds?: number };
    if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000).toISOString().substring(0, 10);
    return '';
}
